export default __webpack_public_path__ + "static/media/HeroImageDuoGourmet.7bffae87.png";